import { ServiceFetch } from '../service-fetch'

export default class InvoiceCustomerCreditNoteModel extends ServiceFetch {
    getInvoiceCustomerCreditNoteBy = (data) => this.authFetch({
        url: 'invoice-customer-credit-note/getInvoiceCustomerCreditNoteBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}